// import React, { useState, useEffect } from "react";
import "./UserProfile.css";

// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const UserProfile = () => {
//   const [targetPrice, setTargetPrice] = useState("");
//   const BASE_URL = "http://localhost:8000";
//   const userName = localStorage.getItem("username");
//   console.log("UserName", userName);
//   const savedUser = JSON.parse(localStorage.getItem("userProfile")) || {
//     username: userName,
//     firstName: "",
//     lastName: "",
//     email: "",
//     expectedChange: 1,
//   };
//   const [user, setUser] = useState(savedUser);

//   const [editMode, setEditMode] = useState({
//     username: false,
//     firstName: false,
//     lastName: false,
//     email: false,
//     expectedChange: false,
//   });

//   const handleEdit = (field) => {
//     setEditMode((prev) => ({ ...prev, [field]: !prev[field] }));
//     setEditMode((prev) => {
//       const newMode = { ...prev, [field]: !prev[field] };

//       if (prev[field] === true) {
//         localStorage.setItem("userProfile", JSON.stringify(user));
//         console.log(`💾 Saved ${field} to localStorage`);
//       }

//       return newMode;
//     });
//   };

//   const handleChange = (e, field) => {
//     setUser((prev) => ({ ...prev, [field]: e.target.value }));
//   };
//   useEffect(() => {
//     const saved = localStorage.getItem("userProfile");
//     if (saved) {
//       setUser(JSON.parse(saved));
//     }
//   }, []);
//   //   const nseCode = "RELIANCE";
//   //   console.log("NseCode", nseCode);
//   const navigate = useNavigate();
//   //   useEffect(() => {
//   //     const fetchData = async () => {
//   //       try {
//   //         const response = await axios.get(`${BASE_URL}/api/stocktarget`, {
//   //           params: { symbol: nseCode },
//   //         });
//   //         console.log("Response");
//   //         setTargetPrice(response.data);
//   //       } catch (err) {
//   //         console.log("Error", err.message);
//   //       }
//   //     };
//   //     fetchData();
//   //   }, [nseCode]);
//   //   console.log("Target Price", targetPrice);
//   //   const target_price = targetPrice?.priceTarget?.Mean;
//   //   console.log("Final target Price", target_price);
//   console.log("User", user);
//   return (
//     <>
//       <div className="user-profile-card">
//         {/* Username */}
//         <div className="user-profile-input">
//           <label>Username:</label>
//           <div className="right-section">
//             {editMode.username ? (
//               <input
//                 type="text"
//                 value={user.username}
//                 onChange={(e) => handleChange(e, "username")}
//               />
//             ) : (
//               <span>{user.username}</span>
//             )}
//             <button onClick={() => handleEdit("username")}>
//               {editMode.username ? "Save" : "Edit"}
//             </button>
//           </div>
//         </div>

//         {/* First Name */}
//         <div className="user-profile-input">
//           <label>First Name:</label>
//           <div className="right-section">
//             {editMode.firstName ? (
//               <input
//                 type="text"
//                 value={user.firstName}
//                 onChange={(e) => handleChange(e, "firstName")}
//               />
//             ) : (
//               <span>{user.firstName}</span>
//             )}
//             <button onClick={() => handleEdit("firstName")}>
//               {editMode.firstName ? "Save" : "Edit"}
//             </button>
//           </div>
//         </div>

//         {/* Last Name */}
//         <div className="user-profile-input">
//           <label>Last Name:</label>
//           <div className="right-section">
//             {editMode.lastName ? (
//               <input
//                 type="text"
//                 value={user.lastName}
//                 onChange={(e) => handleChange(e, "lastName")}
//               />
//             ) : (
//               <span>{user.lastName}</span>
//             )}
//             <button onClick={() => handleEdit("lastName")}>
//               {editMode.lastName ? "Save" : "Edit"}
//             </button>
//           </div>
//         </div>
//         <div className="user-profile-input">
//           <label>Email Address:</label>
//           <div className="right-section">
//             {editMode.lastName ? (
//               <input
//                 type="text"
//                 value={user.email}
//                 onChange={(e) => handleChange(e, "email")}
//               />
//             ) : (
//               <span>{user.email}</span>
//             )}
//             <button onClick={() => handleEdit("email")}>
//               {editMode.lastName ? "Save" : "Edit"}
//             </button>
//           </div>
//         </div>

//         {/* Expected Change */}
//         <div className="user-profile-input">
//           <label>Expected Change:</label>
//           <div className="right-section">
//             {editMode.expectedChange ? (
//               <div className="range-container">
//                 <span className="range-value" style={{ textAlign: "center" }}>
//                   {user.expectedChange}
//                 </span>
//                 <input
//                   type="range"
//                   min="1"
//                   max="10"
//                   value={user.expectedChange}
//                   onChange={(e) => handleChange(e, "expectedChange")}
//                 />
//               </div>
//             ) : (
//               <span>{user.expectedChange}</span>
//             )}
//             <button onClick={() => handleEdit("expectedChange")}>
//               {editMode.expectedChange ? "Save" : "Edit"}
//             </button>
//           </div>
//         </div>
//         <div className="watchlist">
//           <button onClick={() => navigate("/watchlist")}>
//             Manage My Watchlist
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default UserProfile;
// import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// const UserProfile = () => {
//   const navigate = useNavigate();
//   const userName = localStorage.getItem("username");
//   console.log("Username", userName);
//   const [user, setUser] = useState({
//     username: userName,
//     firstName: "",
//     lastName: "",
//     email: "",
//     expectedChange: 1,
//   });

//   const [editMode, setEditMode] = useState({
//     username: false,
//     firstName: false,
//     lastName: false,
//     email: false,
//     expectedChange: false,
//   });

//   // ✅ Load saved profile data from localStorage on mount
//   useEffect(() => {
//     const savedUser = localStorage.getItem("userProfile");
//     if (savedUser) {
//       setUser(JSON.parse(savedUser));
//     }
//   }, []);

//   // ✅ Update user fields
//   const handleChange = (e, field) => {
//     setUser((prev) => ({ ...prev, [field]: e.target.value }));
//   };

//   // ✅ Toggle edit mode and save on "Save"
//   const handleEdit = (field) => {
//     setEditMode((prev) => {
//       const newMode = { ...prev, [field]: !prev[field] };

//       // 💾 Save to localStorage when switching from edit → view (Save clicked)
//       if (prev[field] === true) {
//         localStorage.setItem("userProfile", JSON.stringify(user));
//         console.log(`💾 Saved ${field} to localStorage`);
//       }

//       return newMode;
//     });
//   };

//   return (
//     <div className="user-profile-card">
//       {/* Username */}
//       <div className="user-profile-input">
//         <label>Username:</label>
//         <div className="right-section">
//           {editMode.username ? (
//             <input
//               type="text"
//               value={user.username}
//               onChange={(e) => handleChange(e, "username")}
//             />
//           ) : (
//             <span>{user.username}</span>
//           )}
//           <button onClick={() => handleEdit("username")}>
//             {editMode.username ? "Save" : "Edit"}
//           </button>
//         </div>
//       </div>

//       {/* First Name */}
//       <div className="user-profile-input">
//         <label>First Name:</label>
//         <div className="right-section">
//           {editMode.firstName ? (
//             <input
//               type="text"
//               value={user.firstName}
//               onChange={(e) => handleChange(e, "firstName")}
//             />
//           ) : (
//             <span>{user.firstName}</span>
//           )}
//           <button onClick={() => handleEdit("firstName")}>
//             {editMode.firstName ? "Save" : "Edit"}
//           </button>
//         </div>
//       </div>

//       {/* Last Name */}
//       <div className="user-profile-input">
//         <label>Last Name:</label>
//         <div className="right-section">
//           {editMode.lastName ? (
//             <input
//               type="text"
//               value={user.lastName}
//               onChange={(e) => handleChange(e, "lastName")}
//             />
//           ) : (
//             <span>{user.lastName}</span>
//           )}
//           <button onClick={() => handleEdit("lastName")}>
//             {editMode.lastName ? "Save" : "Edit"}
//           </button>
//         </div>
//       </div>

//       {/* Email Address */}
//       <div className="user-profile-input">
//         <label>Email Address:</label>
//         <div className="right-section">
//           {editMode.email ? (
//             <input
//               type="text"
//               value={user.email}
//               onChange={(e) => handleChange(e, "email")}
//             />
//           ) : (
//             <span>{user.email}</span>
//           )}
//           <button onClick={() => handleEdit("email")}>
//             {editMode.email ? "Save" : "Edit"}
//           </button>
//         </div>
//       </div>

//       {/* Expected Change */}
//       <div className="user-profile-input">
//         <label>Projected %Change </label>
//         <div className="right-section">
//           {editMode.expectedChange ? (
//             <div className="range-container">
//               <span className="range-value" style={{ textAlign: "center" }}>
//                 {user.expectedChange}
//               </span>
//               <input
//                 type="range"
//                 min="1"
//                 max="10"
//                 value={user.expectedChange}
//                 onChange={(e) => handleChange(e, "expectedChange")}
//               />
//             </div>
//           ) : (
//             <span>{user.expectedChange}%</span>
//           )}
//           <button onClick={() => handleEdit("expectedChange")}>
//             {editMode.expectedChange ? "Save" : "Edit"}
//           </button>
//         </div>
//       </div>

//       {/* Watchlist Button */}
//       <div className="watchlist">
//         <button onClick={() => navigate("/watchlist")}>
//           Manage My Watchlist
//         </button>
//       </div>
//     </div>
//   );
// };
import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { useAuth } from "../../context/AuthNewContext";

const UserProfile = () => {
  const navigate = useNavigate();

  const { fetchUserProfile, updateUser } = useUser();
  const { logout } = useAuth();
  const [user, setUser] = useState({
    username: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    countryCode: "",
  });

  const [editMode, setEditMode] = useState({
    username: false,
    firstName: false,
    middleName: false, // ✅ added
    lastName: false,
    email: false,
    phoneNumber: false, // ✅ added
    address1: false, // ✅ added
    city: false, // ✅ added
    state: false, // ✅ added
  });
  /* ================= FETCH FROM CONTEXT ================= */
  useEffect(() => {
    const loadProfile = async () => {
      const data = await fetchUserProfile();

      if (data) {
        setUser({
          username: data.emailAddress,
          firstName: data.firstName || "",
          middleName: data.middleName || "",
          lastName: data.lastName || "",
          email: data.emailAddress || "",
          phoneNumber: data.phoneNumber || "",
          address1: data.Address1 || "",
          address2: data.Address2 || "",
          city: data.City || "",
          state: data.State || "",
          zipcode: data.Zipcode || "",
          country: data.Country || "",
          countryCode: data.countryCode || "",
        });
      }
    };

    loadProfile();
  }, []);
  console.log("User", user);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e, field) => {
    setUser((prev) => ({ ...prev, [field]: e.target.value }));
  };

  /* ================= HANDLE SAVE ================= */
  const handleEdit = async (field) => {
    if (editMode[field]) {
      // 🔥 CALL CONTEXT FUNCTION
      await updateUser({
        firstName: user.firstName,
        middleName: user.middleName,
        lastName: user.lastName,
        phoneNumber: user.phoneNumber,
        address1: user.address1,
        address2: user.address2,
        city: user.city,
        state: user.state,
        zipcode: user.zipcode,
        country: user.country,
        countryCode: user.countryCode,
      });
    }

    setEditMode((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleChangePassword = () => {
    logout();
    navigate("/reset-password");
  };

  return (
    <div className="user-profile-card">
      {/* Username */}
      <div className="user-profile-input">
        <label>Username:</label>
        <div className="right-section">
          <span>{user.username}</span>
        </div>
      </div>

      {/* First Name */}
      {/* <div className="user-profile-input">
        <label>First Name:</label>
        <div className="right-section">
          {editMode.firstName ? (
            <input
              type="text"
              value={user.firstName}
              onChange={(e) => handleChange(e, "firstName")}
            />
          ) : (
            <span>{user.firstName}</span>
          )}
          <button onClick={() => handleEdit("firstName")}>
            {editMode.firstName ? "Save" : "Edit"}
          </button>
        </div>
      </div>

      <div className="user-profile-input">
        <label>Middle Name:</label>
        <div className="right-section">
          {editMode.middleName ? (
            <input
              value={user.middleName}
              onChange={(e) => handleChange(e, "middleName")}
            />
          ) : (
            <span>{user.middleName}</span>
          )}
          <button onClick={() => handleEdit("middleName")}>
            {editMode.middleName ? "Save" : "Edit"}
          </button>
        </div>
      </div>


      <div className="user-profile-input">
        <label>Last Name:</label>
        <div className="right-section">
          {editMode.lastName ? (
            <input
              type="text"
              value={user.lastName}
              onChange={(e) => handleChange(e, "lastName")}
            />
          ) : (
            <span>{user.lastName}</span>
          )}
          <button onClick={() => handleEdit("lastName")}>
            {editMode.lastName ? "Save" : "Edit"}
          </button>
        </div>
      </div>
      <div className="user-profile-input">
        <label>Mobile:</label>
        <div className="right-section">
          {editMode.phoneNumber ? (
            <input
              value={user.phoneNumber}
              onChange={(e) => handleChange(e, "phoneNumber")}
            />
          ) : (
            <span>{user.phoneNumber}</span>
          )}
          <button onClick={() => handleEdit("phoneNumber")}>
            {editMode.phoneNumber ? "Save" : "Edit"}
          </button>
        </div>
      </div>

      <div className="user-profile-input">
        <label>Address:</label>
        <div className="right-section">
          {editMode.address1 ? (
            <input
              value={user.address1}
              onChange={(e) => handleChange(e, "address1")}
            />
          ) : (
            <span>{user.address1}</span>
          )}
          <button onClick={() => handleEdit("address1")}>
            {editMode.address1 ? "Save" : "Edit"}
          </button>
        </div>
      </div>
      <div className="user-profile-input">
        <label>City:</label>
        <div className="right-section">
          {editMode.city ? (
            <input
              value={user.city}
              onChange={(e) => handleChange(e, "city")}
            />
          ) : (
            <span>{user.city}</span>
          )}
          <button onClick={() => handleEdit("city")}>
            {editMode.city ? "Save" : "Edit"}
          </button>
        </div>
      </div> */}

      {/* First Name */}
      <div className="user-profile-input">
        <label>First Name:</label>
        <div className="right-section">
          {editMode.firstName ? (
            <input
              type="text"
              value={user.firstName}
              onChange={(e) => handleChange(e, "firstName")}
            />
          ) : (
            <span>{user.firstName}</span>
          )}
          <button onClick={() => handleEdit("firstName")}>
            {editMode.firstName ? "Save" : "Edit"}
          </button>
        </div>
      </div>

      {/* Middle Name */}
      <div className="user-profile-input">
        <label>Middle Name:</label>
        <div className="right-section">
          {editMode.middleName ? (
            <input
              type="text"
              value={user.middleName}
              onChange={(e) => handleChange(e, "middleName")}
            />
          ) : (
            <span>{user.middleName}</span>
          )}
          <button onClick={() => handleEdit("middleName")}>
            {editMode.middleName ? "Save" : "Edit"}
          </button>
        </div>
      </div>

      {/* Last Name */}
      <div className="user-profile-input">
        <label>Last Name:</label>
        <div className="right-section">
          {editMode.lastName ? (
            <input
              type="text"
              value={user.lastName}
              onChange={(e) => handleChange(e, "lastName")}
            />
          ) : (
            <span>{user.lastName}</span>
          )}
          <button onClick={() => handleEdit("lastName")}>
            {editMode.lastName ? "Save" : "Edit"}
          </button>
        </div>
      </div>

      {/* Mobile */}
      <div className="user-profile-input">
        <label>Mobile:</label>
        <div className="right-section">
          {editMode.phoneNumber ? (
            <input
              type="text"
              value={user.phoneNumber}
              onChange={(e) => handleChange(e, "phoneNumber")}
            />
          ) : (
            <span>{user.phoneNumber}</span>
          )}
          <button onClick={() => handleEdit("phoneNumber")}>
            {editMode.phoneNumber ? "Save" : "Edit"}
          </button>
        </div>
      </div>

      {/* Address */}
      <div className="user-profile-input">
        <label>Address:</label>
        <div className="right-section">
          {editMode.address1 ? (
            <input
              type="text"
              value={user.address1}
              onChange={(e) => handleChange(e, "address1")}
            />
          ) : (
            <span>{user.address1}</span>
          )}
          <button onClick={() => handleEdit("address1")}>
            {editMode.address1 ? "Save" : "Edit"}
          </button>
        </div>
      </div>

      {/* City */}
      <div className="user-profile-input">
        <label>City:</label>
        <div className="right-section">
          {editMode.city ? (
            <input
              type="text"
              value={user.city}
              onChange={(e) => handleChange(e, "city")}
            />
          ) : (
            <span>{user.city}</span>
          )}
          <button onClick={() => handleEdit("city")}>
            {editMode.city ? "Save" : "Edit"}
          </button>
        </div>
      </div>
      {/* <div className="user-profile-input">
        <label onClick={handleChangePassword}>Change Password</label>
       
      </div> */}

      {/* Expected Change */}
      {/* <div className="user-profile-input">
        <label>Projected %Change</label>
        <div className="right-section">
          {editMode.expectedChange ? (
            <div className="range-container">
              <span>{user.expectedChange}</span>
              <input
                type="range"
                min="1"
                max="10"
                value={user.expectedChange}
                onChange={(e) => handleChange(e, "expectedChange")}
              />
            </div>
          ) : (
            <span>{user.expectedChange}%</span>
          )}
          <button onClick={() => handleEdit("expectedChange")}>
            {editMode.expectedChange ? "Save" : "Edit"}
          </button>
        </div>
      </div> */}
      <div className="watchlist">
        <button onClick={handleChangePassword}>Change Password</button>
      </div>

      {/* Watchlist */}
      <div className="watchlist">
        <button onClick={() => navigate("/watchlist")}>
          Manage My Watchlist
        </button>
      </div>
    </div>
  );
};

// export default UserProfile;
export default UserProfile;
